import { QuestionBase, QuestionBaseParams, QuestionUITypes } from './question-base';

export class DecimalboxQuestion extends QuestionBase<number> {
  public questionType: QuestionUITypes = QuestionUITypes.DECIMAL;

  constructor(questionParams: QuestionBaseParams<number>) {
    super(questionParams);
  }

  public getValueForRequest() : number{
    return parseFloat( this.getAvailableValue() );
  }
}


// WEBPACK FOOTER //
// ./src/app/question-decimalbox.ts